import { singleSelectRow } from 'owa-mail-actions';
import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
import TableView from 'owa-mail-list-store/lib/store/schema/TableView';
import MailListItemSelectionSource from 'owa-mail-store/lib/store/schema/MailListItemSelectionSource';
import store from 'owa-mail-store/lib/store/Store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';

function getEffectiveNextSelection(): string {
    // If user has selected "ReturnToView" ensure it is compatible with layout
    // Else return user's NextSelection
    const userConfig = getUserConfiguration().UserOptions;
    if (
        userConfig.NextSelection == 'ReturnToView' &&
        userConfig.GlobalReadingPanePositionReact !== ReadingPanePosition.Off
    ) {
        return 'Next';
    }
    return userConfig.NextSelection;
}

function getRowIndexToSelect(
    lastSelectedRowIndex: number,
    selectionDirection: string,
    tableViewLength: number
): number {
    let indexToSelect = lastSelectedRowIndex;
    if (selectionDirection == 'Previous') {
        indexToSelect--;
    }

    // If the selection index ends up out of bounds, reset it to
    // either the top or the bottom of the list
    if (indexToSelect < 0) {
        indexToSelect = 0;
    } else if (indexToSelect > tableViewLength - 1) {
        indexToSelect = tableViewLength - 1;
    }

    return indexToSelect;
}

export default function selectNewItemUponRowRemoval(
    tableView: TableView,
    lastSelectedRowIndex: number,
    lastSelectedRowWasPinned: boolean
): void {
    const tableViewLength = tableView.rowKeys.length;
    const showReadingPane = store.mailModule.showReadingPane;
    let selectionSource = MailListItemSelectionSource.RowRemoval;
    const selectionDirection = getEffectiveNextSelection();

    // Nothing to do if the table is empty or user setting is set to return
    if (selectionDirection == 'ReturnToView' || tableViewLength == 0) {
        return;
    }

    // Get the index of the item to select
    let indexToSelect = getRowIndexToSelect(
        lastSelectedRowIndex,
        selectionDirection,
        tableViewLength
    );

    // When the user's setting is set to select 'previous' and  the top
    // non-pinned item was deleted, we should  not select the last pinned item
    // automatically. We should instead fallback to 'next' behavior so the top
    // non-pinned item gets selected again. Note that If the user is already in
    // the pinned section we will maintain the existing behavior (and select
    // previous item)
    if (selectionDirection == 'Previous') {
        const rowKeyToSelect = tableView.rowKeys[indexToSelect];
        const wouldEnterPinnedSection =
            MailRowDataPropertyGetter.getIsPinned(rowKeyToSelect, tableView) &&
            !lastSelectedRowWasPinned;

        if (wouldEnterPinnedSection) {
            indexToSelect = getRowIndexToSelect(lastSelectedRowIndex, 'Next', tableViewLength);
        }
    }

    const rowKey = tableView.rowKeys[indexToSelect];

    // if we are in single line view and remove an item while the reading pane is open, we want to automatically open the prev/next item
    if (
        getUserConfiguration().UserOptions.GlobalReadingPanePositionReact ==
            ReadingPanePosition.Off &&
        showReadingPane
    ) {
        selectionSource = MailListItemSelectionSource.ImmersiveReadingPaneDelete;
    }
    singleSelectRow(tableView, rowKey, false /* isUserNavigation */, selectionSource);
}
